import { render, staticRenderFns } from "./Ncity.vue?vue&type=template&id=460497d2&scoped=true"
import script from "./Ncity.vue?vue&type=script&lang=js"
export * from "./Ncity.vue?vue&type=script&lang=js"
import style0 from "./Ncity.vue?vue&type=style&index=0&id=460497d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460497d2",
  null
  
)

export default component.exports